/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="employeeServiceTimesPricing.module.ts" />

module Meevo.Plugins.EmployeeServiceTimesPricing {
    export interface IEmployeeServiceTimesPricing {
        employeeCode: string;
        employeeGlobalId: string;
        employeeServiceSteps: Meevo.Model.ServiceStepOverride[];
        firstName: string;
        lastName: string;
        price: number;
        priceLevel: Meevo.Model.PriceLevelEnum
        serviceDisplayName: string;
        serviceGlobalId: string;
        serviceStepsTotalTime: number;
    }
    export interface ITimesPriceFilter {
        employee?: Meevo.Model.DataDetail;
        service?: Meevo.Model.DataDetail;
        priceLevel?: Meevo.Model.PriceLevelEnum;
    }

    
    class EmployeeServiceTimesPricingController {

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected baseEndpoint: string;
        protected items: any;
        protected priceLevels = [{ value: null, label: 'All' }];
        protected filter: ITimesPriceFilter;
        protected request: {};
        protected showSearch = true;
        static $inject = ["meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "$filter",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout"]

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected $filter: ng.IFilterService,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService) {

            this.initialize();

            this.baseEndpoint = this.appSettings.API_ENDPOINTS.employeeServiceTimesPricing;

            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, this.baseEndpoint);

        }

        closeContext = (): void => {
            this.$rootScope.$broadcast("closeContext", this.$state.current, null);
        }

        initialize = (): void => {
            this.clearFilters();
            for (var level in Meevo.Model.PriceLevelEnum) {
                if (!Number(Meevo.Model.PriceLevelEnum[level])) {
                    const priceLevel = Meevo.Model.PriceLevelEnum[level];
                    this.priceLevels.push({ value: level, label: `Level ${priceLevel.substr(-1, 1)}` });
                }
            }
        }

        clearFilters = (): void => {
            this.filter = {
                employee: null,
                service: null,
                priceLevel: null,
            }

            this.request = {
                pageNumber: 0,
                itemsPerPage: 50,
                criteria: {
                    employeeId: null,
                    serviceId: null,
                    priceLevel: null,
                }
            };
        }

        onResetFilter = (): void => {
            this.request = {
                pageNumber: 0,
                itemsPerPage: 50,
                criteria: {
                    employeeId: this.filter.employee && this.filter.employee.id,
                    serviceId: this.filter.service && this.filter.service.id,
                    priceLevel: this.filter.priceLevel
                }
            };

            const trackingItem = new Model.TrackingItem(Model.NounEnum.EmployeeServiceTimesPricingPage, Model.VerbEnum.SearchButtonClicked, this.request, null);
            this.trackingService.saveTrackingInfo(trackingItem);
            this.items.initSearch(this.request);

        }

        onExport = (): void => {
            const criteria = { ...this.request, ...{ itemsPerPage: Meevo.Components.Common.Constants.MAX_INT_VALUE, pageNumber: 0 } }

            let trackingItem = new Model.TrackingItem(Model.NounEnum.EmployeeServiceTimesPricingPage, Model.VerbEnum.ExportButtonClicked, criteria, null);
            this.trackingService.saveTrackingInfo(trackingItem);

            this.dataService.getListPaged(this.baseEndpoint, criteria).then((res: IEmployeeServiceTimesPricing[]) => {
                if (!!res && res.length > 0) {
                    this.processData(res);
                } else {
                    this.modalService.alert('ERROR_UNABLE_TO_PROCESS_DATA_FILE');
                }
            });
        }

        processData = (data: object[]): void => {
            const sources = ['employeeDisplayName', 'serviceDisplayName', 'priceLevelDisplay', 'price', 'serviceChargeAmount', 'totalPrice', 'stepsTotalTime', 'steps', 'stepNumber', 'stepTypeDisplay', 'minutes']
            const employee = this.$translate.instant('LABEL_EMPLOYEE');
            const service = this.$translate.instant('LABEL_SERVICE');
            const serviceCharges = this.$translate.instant('LABEL_SERVICE_CHARGES');
            const priceLevel = this.$translate.instant('LABEL_PRICE_LEVEL');
            const price = this.$translate.instant('LABEL_PRICE');
            const totalPrice = this.$translate.instant('LABEL_TOTAL_PRICE');
            const stepTotalTime = this.$translate.instant('LABEL_STEP_TOTAL_TIME');
            
            const header = [employee, service, priceLevel, price, serviceCharges, totalPrice, stepTotalTime, 'steps-1-stepNumber', 'steps-1-stepTypeDisplay', 'steps-1-minutes', 'steps-2-stepNumber', 'steps-2-stepTypeDisplay', 'steps-2-minutes', 'steps-3-stepNumber', 'steps-3-stepTypeDisplay', 'steps-3-minutes', 'steps-4-stepNumber', 'steps-4-stepTypeDisplay', 'steps-4-minutes', 'steps-5-stepNumber', 'steps-5-stepTypeDisplay', 'steps-5-minutes']
            var file = [];
            const props = ['employeeDisplayName', 'serviceDisplayName', 'priceLevelDisplay', 'price', 'serviceChargeAmount', 'totalPrice', 'stepsTotalTime', 'steps-1-stepNumber', 'steps-1-stepTypeDisplay', 'steps-1-minutes', 'steps-2-stepNumber', 'steps-2-stepTypeDisplay', 'steps-2-minutes', 'steps-3-stepNumber', 'steps-3-stepTypeDisplay', 'steps-3-minutes', 'steps-4-stepNumber', 'steps-4-stepTypeDisplay', 'steps-4-minutes', 'steps-5-stepNumber', 'steps-5-stepTypeDisplay', 'steps-5-minutes']
            data.forEach(row => {
                let record = Meevo.Components.Common.DataExportService.flatObject(row, sources, props);
                file.push(record);
            })

            _.defer(() => { Meevo.Components.Common.DataExportService.exportToCsv(file, 'pricing.csv', header, props) });

        }



    }
    angular.module("meevo.plugins.employeeServiceTimesPricing", [])
        .controller("meevo.plugins.employeeServiceTimesPricing.EmployeeServiceTimesPricingController", EmployeeServiceTimesPricingController);
}
